import React, { Component } from "react";
import Api from "Api/Api";
import DataGrid, { Column, Editing, Form } from "devextreme-react/data-grid";
import { Item } from "devextreme-react/form";
import moment from "moment";
import { whoseContactList } from "formFields";

export default class Reminders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subject_id: null,
      reminders: null,
    };
    this.reminderAdded = (record) => {
      record.data.type = this.props.type;
      if (record.data.type === "startup") {
        record.data.startup = this.state.subject_id;
      } else {
        record.data.investor = this.state.subject_id;
      }
      Api.createReminders(
        this.props.type,
        this.state.subject_id,
        record.data
      ).then((response) => {
        if (response.status === 201) {
          this.setState({
            reminders: [...this.state.reminders, response.data],
          });
        }
      });
    };
    this.reminderRemoved = (record) => {
      Api.deleteReminders(record.data.id).then((response) => {
        let updatedReminders = this.state.reminders.filter((rec) => {
          return rec.id !== record.data.id;
        });
        this.setState({ reminders: updatedReminders });
      });
    };
    this.loadData = () => {
      this.setState({ subject_id: this.props.id }, () => {
        Api.getReminders(this.props.type, this.state.subject_id).then(
          (response) => {
            if (response) {
              if (response.status === 200) {
                this.setState({ reminders: response.data.results });
              }
            } else {
              this.setState({ reminders: [] });
            }
          }
        );
      });
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.id !== this.state.subject_id) {
      this.loadData();
    }
  }
  componentDidMount() {
    this.loadData();
  }

  render() {
    return (
      <div>
        <h3>Reminders</h3>
        <DataGrid
          dataSource={this.state.reminders}
          searchPanel={{ visible: true }}
          wordWrapEnabled={true}
          hoverStateEnabled={true}
          onRowInserting={this.reminderAdded}
          onRowRemoved={this.reminderRemoved}
          onRowUpdating={this.startupUpdated}
          edit
        >
          <Editing
            mode={"popup"}
            allowDeleting={true}
            allowAdding={true}
            useIcons={true}
            popup={{ height: "40%", width: "40%" }}
          >
            <Form colCount={1} showColonAfterLabel={false}>
              <Item dataField="text" isRequired />
              <Item
                dataField="reminder_date"
                editorType="dxDateBox"
                editorOptions={{
                  acceptCustomValue: false,
                  type: "datetime",
                }}
                isRequired
              />
              <Item
                dataField="reminder_by"
                editorType="dxSelectBox"
                editorOptions={{
                  dataSource: [...whoseContactList, "Others"],
                }}
                isRequired
              />
            </Form>
          </Editing>
          <Column dataField={"text"} />
          <Column
            dataField={"reminder_date"}
            cellRender={(row) => {
              return <div>{moment(row.data.reminder_date).format("LLLL")}</div>;
            }}
          />
          <Column dataField={"reminder_by"} />
        </DataGrid>
      </div>
    );
  }
}
